module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "delete-organization"
  }, [_c('v-layout', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "flat": "",
      "disabled": !_vm.showForm
    },
    on: {
      "click": function($event) {
        _vm.showDeleteDialog = true
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("account.delete-organization")) + "\n      ")])], 1)], 1), _vm._v(" "), (_vm.showForm) ? _c('v-form', {
    ref: "editOrganizationForm",
    staticClass: "organization-form",
    model: {
      value: (_vm.validated),
      callback: function($$v) {
        _vm.validated = $$v
      },
      expression: "validated"
    }
  }, [_c('div', {
    staticClass: "ma-3 mb-5"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("account.basic-information")))]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.editNameLabel,
      "required": "",
      "rules": [function (v) { return !!v || _vm.$t('account.vali-org-name'); }],
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.edit.name),
      callback: function($$v) {
        _vm.$set(_vm.edit, "name", $$v)
      },
      expression: "edit.name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('account.description')
    },
    model: {
      value: (_vm.edit.description),
      callback: function($$v) {
        _vm.$set(_vm.edit, "description", $$v)
      },
      expression: "edit.description"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ma-3"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("account.contact")))]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('account.incharge')
    },
    model: {
      value: (_vm.edit.contact),
      callback: function($$v) {
        _vm.$set(_vm.edit, "contact", $$v)
      },
      expression: "edit.contact"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('account.tel'),
      "rules": _vm.phoneRules
    },
    model: {
      value: (_vm.edit.phone),
      callback: function($$v) {
        _vm.$set(_vm.edit, "phone", $$v)
      },
      expression: "edit.phone"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('account.email'),
      "rules": _vm.emailRules
    },
    model: {
      value: (_vm.edit.email),
      callback: function($$v) {
        _vm.$set(_vm.edit, "email", $$v)
      },
      expression: "edit.email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-box"
  }, [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "color": "primary",
      "disabled": _vm.btnDisable || !_vm.validated
    },
    on: {
      "click": _vm.updateOrganization
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("account.edit")) + "\n      ")])], 1)]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "max-width": "300px"
    },
    model: {
      value: (_vm.showDeleteDialog),
      callback: function($$v) {
        _vm.showDeleteDialog = $$v
      },
      expression: "showDeleteDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        " + _vm._s(_vm.$t('account.caution-title')) + "\n      ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_vm._v("\n        " + _vm._s(_vm.$t('account.caution-org-remove-text'))), _c('br'), _c('br'), _vm._v("\n        " + _vm._s(_vm.edit.name)), _c('br')]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteOrganization($event)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('account.delete')) + "\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDeleteDialog = false
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('account.cancel')) + "\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../src/~/vue-loader/lib/template-compiler?{"id":"data-v-0a2e76c1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../src/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountOrganizationsDetail.vue
// module id = 1906
// module chunks = 0